import { AnimatedCheckmark } from '#/components/Icon/AnimatedCheckmark';
import { BodySmall } from '#/components/Text/BodySmall';
import { useI18n } from '#/i18n/hooks/useI18n';
import { colors } from '#/theme/theme';

export function ListingViewAppliedMessage() {
  const { i18n } = useI18n();

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <div
        style={{
          width: 24,
          height: 24,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          marginRight: '8px',
          borderRadius: '50%',
          background: colors.brandGreen,
        }}
      >
        <AnimatedCheckmark size={12} colorName="white" />
      </div>

      <BodySmall>{i18n('Thank you for applying!')}</BodySmall>
    </div>
  );
}
